import isInKwaiying from '../isInKwaiying';
import callNative from '../callNative';
import { getMarketUrl, getToAppName } from './base';
import getDeviceInfo from '../getDeviceInfo';
import onVisibleChange from '../onVisibleChange';
import getDefer from '../getDefer';
import getVisible from '../getVisible/index.web';
import isIphone from '../isIphone';
import appInfoMap from '../isAppInstall/appInfoMap';
import request from '../request';
import clipboard from '../clipboard';
import getAppName from '../getAppName';
import { downloadApk } from './downloadApk';
const shareTipImg = 'https://ali2.a.kwimgs.com/udata/pkg/kmovie/share_tip_open.png';
let tipEl;
export function wxTip(callback) {
    if (tipEl) {
        tipEl.style.display = 'block';
    }
    else {
        tipEl = document.createElement('div');
        // better performance then set style attributes
        // eslint-disable-next-line max-len
        tipEl.style.cssText = `position:fixed;top:0;left:0;right:0;bottom:0;background-image:url(${shareTipImg});background-color:rgba(0,0,0,0.4);background-size:contain;background-repeat:no-repeat;z-index:9999`;
        tipEl.id = 'img-tip';
        document.body.appendChild(tipEl);
        tipEl.addEventListener('click', () => {
            tipEl.style.display = 'none';
            callback && callback();
            return false;
        }, false);
    }
}
let toastEl;
function showToast(text = '正在打开应用...') {
    if (toastEl) {
        toastEl.style.display = 'flex';
    }
    else {
        toastEl = document.createElement('div');
        // better performance then set style attributes
        // eslint-disable-next-line max-len
        toastEl.style.cssText =
            'position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,0.4);z-index:9999;justify-content: center;align-items: center;color: #fff;display: flex;';
        toastEl.id = 'toast-el';
        toastEl.innerHTML = `
            <div style="height: 44px;line-height: 44px;background-color:#222;border-radius: 22px;padding: 0 16px;font-size:10px;">${text}</div>
        `;
        document.body.appendChild(toastEl);
    }
}
function hideToast() {
    toastEl && (toastEl.style.display = 'none');
}
function _open(url, newFrame) {
    if (isIphone() && newFrame !== false) {
        // iphone 优先使用open，但是open有可能被系统阻止，所以加个延时判断
        // 主要为了解决请求被打断问题，后续归因接口可以sendBeacon后可以去掉
        let timer;
        let opened = false;
        const sub = onVisibleChange((visible) => {
            if (!visible) {
                opened = true;
            }
            if (timer) {
                timer = clearTimeout(timer);
            }
            sub.remove();
        }, 0);
        timer = setTimeout(() => {
            const visible = getVisible();
            if (opened || !visible) {
                return;
            }
            _open(url, false);
        }, 2000);
        window.open(url);
        return;
    }
    var a = document.createElement('a');
    a.setAttribute('href', url);
    document.body.appendChild(a);
    a.click();
    a.remove();
}
async function openIframeSchema(url, fallbackUrl, direct = false, setNewAppLink = () => { }, appInfo) {
    showToast();
    // 一般是去商店的情况，或者是没办法fallback的情况，就去设置拉新链接
    if (!fallbackUrl) {
        try {
            await setNewAppLink();
        }
        catch (e) {
            console.log('setNewAppLink error', e);
        }
    }
    let timer;
    let opened = false;
    const sub = onVisibleChange((visible) => {
        if (!visible) {
            hideToast();
            defer.resolve(true);
            opened = true;
        }
        if (timer) {
            timer = clearTimeout(timer);
        }
        sub.remove();
    }, 0);
    const defer = getDefer();
    _open(url);
    timer = setTimeout(() => {
        const visible = getVisible();
        if (opened || !visible) {
            hideToast();
            return;
        }
        if (fallbackUrl) {
            sub.remove();
            defer.resolve(openIframeSchema(fallbackUrl, '', direct, setNewAppLink, appInfo));
        }
        else {
            hideToast();
            if (!isIphone() && appInfo?.getApkUrl) {
                appInfo.getApkUrl(request).then((apkUrl) => {
                    return downloadApk(apkUrl);
                });
            }
            defer.resolve(false);
        }
    }, 2000);
    return defer.promise;
}
/**
 * 打开scheme，去应用商店的情况会丢失链接
 * @param url
 * @returns
 */
async function openKyScheme(url, _OpenOptions) {
    const { appName, platform, isMobile, globalId } = await getDeviceInfo();
    const encodedURI = encodeURIComponent(url);
    const toAppName = _OpenOptions?.toAppName || getToAppName(url);
    const appInfo = appInfoMap[toAppName];
    const markets = getMarketUrl(toAppName);
    const iosAppStoreUrl = markets.iosMarket;
    const iosUniversalUrl = markets.getULink?.(url) || url;
    const yingyongbao = `${markets.yingyongbao}${url ? '&android_schema=' + encodedURI : ''}`;
    const market = markets.androidMarket;
    const isIos = platform?.toLocaleLowerCase() === 'ios';
    if (!isMobile) {
        return openIframeSchema(markets.pc || '', '', true);
    }
    const setNewAppLink = () => {
        return appInfo?.setNewAppLink?.(request, clipboard, {
            schema: url,
            from: _OpenOptions?.lxFrom || _OpenOptions?.from,
            type: _OpenOptions?.lxType,
            content: _OpenOptions?.lxContent,
            egid: _OpenOptions?.lxEgid || globalId,
        });
    };
    if (isIos) {
        if (appName === 'wechat' || appName === 'qq') {
            // 无解， 打开tip
            if (url) {
                wxTip();
                return;
            }
            else {
                // 不指定链接，直接打开应用商店
                return openIframeSchema(iosAppStoreUrl, '', true, setNewAppLink, appInfo);
            }
        }
        else {
            // 优先用UniversalUrl，没安装会去商店
            return openIframeSchema(iosUniversalUrl, '', true, setNewAppLink, appInfo);
        }
    }
    // android
    if (appName === 'wechat' || appName === 'qq') {
        // 优先用应用宝，一般不会失败
        return openIframeSchema(yingyongbao, '', false, setNewAppLink, appInfo);
    }
    else {
        // 优先直接打开，失败了去应用商店
        return openIframeSchema(url, market, false, setNewAppLink, appInfo);
    }
}
export default async function (url, _OpenOptions) {
    if (isInKwaiying()) {
        if (isIphone()) {
            _open(url);
            return;
        }
        return callNative('open', {
            isPromise: false,
            params: {
                url,
                showTopBar: _OpenOptions?.showTopBar || false,
                type: _OpenOptions?.type || 1,
                title: _OpenOptions?.title || '',
                bgColor: _OpenOptions?.bgColor || '#141414',
            },
        });
    }
    if (getAppName() === 'kwai') {
        _open(url);
        return;
    }
    if (url.startsWith('http')) {
        _open(url);
        return;
    }
    return openKyScheme(url, _OpenOptions);
}
